export default "__VITE_ASSET__51016837__"